import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { ExecPatients } from '../components/widgets/ExecPatients';

export default function ExecPatientsPage() {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="מסע המטופל" />
        <main className="flex-1 overflow-y-auto p-6">
          <ExecPatients />
        </main>
      </div>
    </div>
  );
}
